import React from "react";
import PropTypes from "prop-types";
import TrackBoxes from "../Components/Elements/TrackBoxes";
import TrackComment from "../Components/Elements/TrackComment";
import LoadMore from "../Components/Elements/LoadMore";

class LoadMoreContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, type: this.props.type, filter: this.props.filter, items: [] };
  }
  componentDidMount() {
    this.fetch();
  }

  pagination = (e) => {
    e.stopPropagation();
    this.fetch();
  };

  fetch = () => {
    this.props.request(this.state.filter, this.state.page).then(({ data }) => {
      const hasMore = data.length === 30;
      const items = this.state.items;
      data.map((t) => items.push(t));
      this.setState({ items, page: this.state.page + 1, hasMore });
    });
  };

  render = () => {
    const items = this.state.items;
    const { type, hasMore } = this.state;
    const { loading } = this.props;
    if (!loading && items.length === 0) {
      return null;
    }
    return (
      <React.Fragment>
        {!loading && items.length && this.props.track && (
          <div className="totd-header">
            <h3>
              Comments for &ldquo;<span>{this.props.track.title}</span>&rdquo; by <span>{this.props.track.artist}</span>
            </h3>
          </div>
        )}
        {items && type === "track" && <TrackBoxes tracks={items} />}
        {items &&
          (type === "comment" || type === "comment-search") &&
          items.map((comment) => (
            <div key={comment.id}>
              <TrackComment addRe={this.state.addRe} comment={comment} type={type} highlight={this.state.filter} />
            </div>
          ))}

        {!loading && (type === "comment" || type === "comment-search") && items.length === 0 && <div>Nothing found, please try again.</div>}
        <LoadMore loading={loading} hasMore={hasMore} items={items} pagination={this.pagination} />
      </React.Fragment>
    );
  };
}

LoadMoreContainer.propTypes = {
  filter: PropTypes.string.isRequired,
};
LoadMoreContainer.defaultProps = {};
export default LoadMoreContainer;
